import { JobsSearchState } from '../../store/state';
import { JobAction, JobsActions } from '../actions';

const initialState: JobsSearchState = {
  data: null,
  params: null,
  next: "",
  previous: "",
  total_tasks: 0,
  isLoading: false,
  error: '',
};

const jobsSearchReducer = (state: JobsSearchState = initialState, action: JobAction): JobsSearchState => {
  switch (action.type) {
    case JobsActions.CreateJobSuccess:
      return {
        ...state,
      };
    case JobsActions.SearchJobs:
      return {
        ...state,
        error: '',
        isLoading: true,
      };
    case JobsActions.SearchJobsSuccess:
      return {
        ...state,
        data: action.payload.results,
        params: action.payload.params,
        next: action.payload.search_after,
        total_tasks: action.payload.total_hits,
        isLoading: false,
      };
    case JobsActions.SearchJobsError:
      return {
        ...state,
        data: null,
        total_tasks: 0,
        isLoading: false,
        error: action.payload,
      };
    case JobsActions.ReassignJobSuccess: 
      return {
        ...state,
        data: state?.data?.map(task => {
          if (task._id === action.payload._id) {
            return action.payload;
          }
          return task;
        }),
      };   
    case JobsActions.RemoveJobSuccess:
      return {
        ...state,
        data: state?.data?.filter(task => task._id !== action.payload) ?? [],
      };
    case JobsActions.LoadJobSuccess:
      return {
        ...state,
        data: state?.data?.map(task => {
          if (task._id !== action.payload._id) {
            return task
          }
          return action.payload;
         }) ?? [],
      };
    case JobsActions.LoadSessionInfoForTasksSuccess:
      return {
        ...state,
        data: state?.data?.map(task => {
          let rank;
          action.payload?.find(session => {
            const result = session?.body?.body?.tasks?.find(t => t.task_id === task?._id);
            rank = result?.rank;
            return !!result;
          });
          return {
            ...task,
            rank,
          }
        })
      }  
    case JobsActions.LoadFeedbacks:
      return {
        ...state,
        isLoading: true,
      }
    case JobsActions.LoadFeedbacksSuccess:
      return {
        ...state,
        isLoading: false,
        data: state?.data?.map(job => {
          const result = action.payload?.find(feedback => feedback?.body?.body?.[0]?.task_id === job?._id);
          return {
            ...job,
            feedback: {
              ...(job?.feedback ?? {}),
              ...(result?.body?.body?.[0] ?? {})
            }
          }
        })
      };
    case JobsActions.LoadFeedbacksError:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default jobsSearchReducer;
